// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "img[data-v-b2de0ccc]{margin-top:-.2rem;width:.9rem}", "",{"version":3,"sources":["webpack://./src/components/PageLayout/Navbar/NavbarMenu/NavbarMenuItem.vue"],"names":[],"mappings":"AACA,qBACE,iBAAA,CACA,WAAA","sourcesContent":["\nimg {\n  margin-top: -0.2rem;\n  width: 0.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
